import FieldWrapper from '../Field-wrapper';
import styles from '../Fields.module.less';

import { adjustCaretAfterEdit, flexibleDate } from '$Utils';
import { normalizeDateBasic } from '$Validation/Normalizer';

/**
 *
 * @deprecated all new forms should use HVUI/FormikForm and HVUI/FormControl
 */
export const DateFieldPolyfillInput = ({
    disabled,
    id,
    inputClassName,
    name,
    onChange,
    onFocus,
    onBlur,
    pattern,
    placeholder,
    required,
    _value
}) => {
    let value = _value;
    if (value && value.includes('-')) {
        value = flexibleDate(value).format('MM/DD/YYYY');
    }
    return (
        <input
            disabled={disabled}
            id={id || name}
            name={name}
            onBlur={onBlur}
            autoComplete="off"
            onChange={event => {
                const { target } = event;
                adjustCaretAfterEdit(target);
                target.value = normalizeDateBasic(target.value);
                return onChange(event);
            }}
            onFocus={onFocus}
            placeholder={placeholder || 'MM/DD/YYYY'}
            required={required}
            className={styles[inputClassName]}
            type="text"
            value={value}
            data-tc="polyfill"
        />
    );
};

export default FieldWrapper(DateFieldPolyfillInput, { reduxForm: true });
export const DateField = FieldWrapper(DateFieldPolyfillInput);
